var _g, _g2, _path, _path2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderNotFound(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 0C71.4157 0 92 20.5856 92 45.9999C92 71.4152 71.4157 91.9998 46 91.9998C20.5852 91.9998 0 71.4152 0 45.9999C0 20.5856 20.5852 0 46 0Z",
    fill: "#798897"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5 44.5003C91.5 77.0003 68.3067 92.0001 46.0009 92.0001C32 87 25.8808 78.5 15.5 68.0001L22.0429 65.3281C23.1682 64.201 24.5573 63.8048 25.8808 64.0038C27.0069 62.8785 28.1312 61.7532 29.3213 60.628C21.7125 51.0966 33.7633 56.3009 42.5 47.5001C51.9655 38.0354 66.0355 13.0355 75.5 22.5002C83 32.5 85.5 35.5 92.5 44.5003Z",
    fill: "#55606A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6831 57.9143C27.603 50.701 27.603 39.1162 34.6831 32.0342C41.8973 24.9522 53.4809 24.9522 60.5626 32.0342C67.6445 39.2485 67.6445 50.8315 60.5626 57.9143C53.3485 64.9964 41.765 64.9964 34.6831 57.9143Z",
    fill: "#798897"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.9375 31.459H45.2925H18.8672C16.7325 31.459 15 33.1033 15 35.2055V69.5353C15 71.6375 16.7325 73.3437 18.8672 73.3437H73.0078C75.1425 73.3437 76.875 71.6375 76.875 69.5353V39.0742V35.2055V31.459H45.9375Z",
    fill: "#231F20"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9375 28.3652H45.2925H18.8672C16.7325 28.3652 15 30.0096 15 32.1118V66.4416C15 68.5438 16.7325 70.25 18.8672 70.25H73.0078C75.1425 70.25 76.875 68.5438 76.875 66.4416V35.9805V32.1118V28.3652H45.9375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.875 24.5584C76.875 22.4562 75.1425 20.75 73.0078 20.75H53.6719C51.5372 20.75 49.8047 22.4562 49.8047 24.5584C49.8047 24.5584 49.302 28.0497 45.9375 28.3653H76.875V24.5584Z",
    fill: "#D3E1F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderNotFound);
export default __webpack_public_path__ + "static/media/folder-not-found.bacab2a4668ee80005877319863fa71c.svg";
export { ForwardRef as ReactComponent };